import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/one'));
const PageTwo = lazy(() => import('src/pages/dashboard/two'));
const PageThree = lazy(() => import('src/pages/dashboard/three'));
const PageFour = lazy(() => import('src/pages/dashboard/four'));
const PageFive = lazy(() => import('src/pages/dashboard/five'));
const PageSix = lazy(() => import('src/pages/dashboard/six'));
const ThemeSettingsPage = lazy(() => import('src/pages/dashboard/theme-settings'));
const ShopListPage = lazy(() => import('src/pages/dashboard/shops/ShopListPage'));
const ShopCreatePage = lazy(() => import('src/pages/dashboard/shops/ShopCreatePage'));
const ShopEditPage = lazy(() => import('src/pages/dashboard/shops/ShopEditPage'));
const ReferalsListView = lazy(() => import('src/pages/dashboard/referals/list'));
const CaseStudiesPage = lazy(() => import('src/pages/dashboard/CaseStudiesPage'));
const PaymentTariffPage = lazy(() => import('src/pages/dashboard/payment/payment-tariff-page'));
const ChatPage = lazy(() => import('src/pages/dashboard/chat/ChatPage'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard/:shopid',
    element: (
      <AuthGuard userType="user">
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'two', element: <PageTwo /> },
      { path: 'three', element: <PageThree /> },
      { path: 'theme', element: <ThemeSettingsPage /> },
      {
        path: 'group',
        children: [
          { element: <PageFour />, index: true },
          { path: 'five', element: <PageFive /> },
          { path: 'six', element: <PageSix /> },
        ],
      },
    ],
  },
  {
    path: 'dashboard/shops',
    element: (
      <AuthGuard userType="user">
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <ShopListPage />, index: true },
      { path: 'new', element: <ShopCreatePage /> },
      { path: ':id/edit', element: <ShopEditPage /> },
      { path: ':sid/payment', element: <PaymentTariffPage /> },
      { path: ':id/chat', element: <ChatPage /> },
      { path: ':id/chat/:conversationKey', element: <ChatPage /> },
      { path: ':id/chat/new', element: <ChatPage /> },
    ]
  },
  {
    path: 'dashboard/referrals',
    element: (
      <AuthGuard userType="user">
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <ReferalsListView />, index: true },
    ]
  },
  {
    path: 'dashboard/cases',
    element: (
      <AuthGuard userType="user">
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <CaseStudiesPage />, index: true },
    ]
  }
];
